import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { faPaperPlaneTop, faStop } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'c-chat-composer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, ButtonComponent, TranslocoPipe],
  templateUrl: './chat-composer.component.html',
  styleUrl: './chat-composer.component.scss',
})
export class ChatComposerComponent {
  readonly placeholder = input<string>('');
  readonly streaming = input<boolean>(false);

  readonly send = output<string>();
  readonly stop = output<void>();

  protected readonly sendIcon = faPaperPlaneTop;
  protected readonly stopIcon = faStop;

  protected readonly draft = signal<string>('');
  protected readonly canSend = computed(() => this.draft().trim().length > 0);

  protected onInput(event: Event): void {
    this.draft.set((event as CustomEvent<{ value?: string | null }>).detail?.value ?? '');
  }

  protected onSend(): void {
    const message = this.draft().trim();
    if (!message) return;

    this.send.emit(message);
    this.draft.set('');
  }

  protected onStop(): void {
    this.stop.emit();
  }
}
